import React, { useState, useEffect, forwardRef } from 'react';

//komponen
import { withStyles } from '@mui/styles';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';

//gambar
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import EditIcon from '@mui/icons-material/Edit';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import PreviewIcon from '@mui/icons-material/Preview';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgba(108,122,224,255)",
        borderColor: "rgba(108,122,224,255)",
        color: "white"
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "rgba(248,246,255,255)",
            borderColor: "rgba(248,246,255,255)"
        },
    },
}))(TableRow);

function Riwayat_Penjualan(props, ref) {
    //state
    const [tampil_notif, setTampilNotif] = useState(false);
    const [jenis_notif, setJenisNotif] = useState("success");
    const [isi_notif, setIsiNotif] = useState("");
    const [periode1, setPeriode1] = useState(new Date());
    const [periode2, setPeriode2] = useState(new Date());
    const [data_penjualan, setDataPenjualan] = useState([]);
    const [data_metode_bayar, setDataMetodeBayar] = useState([]);
    const [data_anggota, setDataAnggota] = useState([]);
    const [metode_bayar, setMetodeBayar] = useState("");
    const [metode_bayar_sekarang, setMetodeBayarSekarang] = useState("");
    const [nama_metode_bayar_sekarang, setNamaMetodeBayarSekarang] = useState("");
    const [status_ubah, setStatusUbah] = useState("");
    const [status_ubah_pembeli, setStatusUbahPembeli] = useState("");
    const [id_penjualan, setIdPenjualan] = useState("");
    const [id_anggota_sekarang, setIdAnggotaSekarang] = useState("");
    const [nama_anggota_sekarang, setNamaAnggotaSekarang] = useState("");
    const [anggota, setAnggota] = useState(null);
    const [bayar, setBayar] = useState("");
    const [kasir, setKasir] = useState("");
    const [waktu_transaksi, setWaktuTransaksi] = useState("");
    const [data_penjualan_detail, setDataPenjualanDetail] = useState([]);
    const [total, setTotal] = useState(0);
    const [diskon, setDiskon] = useState(0);
    const [pembulatan, setPembulatan] = useState(0);
    const [grand_total, setGrandTotal] = useState(0);
    const [tampil_dialog, setTampilDialog] = useState(false);
    const [tampil_dialog_ubah, setTampilDialogUbah] = useState(false);
    const [tampil_dialog_ubah_pembeli, setTampilDialogUbahPembeli] = useState(false);
    const [tampil_dialog_hapus, setTampilDialogHapus] = useState(false);
    const [tampil_dialog_hapus_anggota, setTampilDialogHapusAnggota] = useState(false);
    const [tampil_dialog_pembatalan, setTampilDialogPembatalan] = useState(false);

    //fungsi    
    useEffect(() => {
        fetch(props.aplikasi + '/metode_bayar/tampil_metode_bayar.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: "ada"
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataMetodeBayar(data.data);
                }
                else {
                    setDataMetodeBayar([]);
                }
            })
            .catch(error => {
                setDataMetodeBayar([]);
            }
            );

        fetch(props.aplikasi + '/karyawan/tampil_karyawan.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: "1"
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataAnggota(data.data);
                }
                else {
                    setDataAnggota([]);
                }
            })
            .catch(error => {
                setDataAnggota([]);
            }
            );
    }, [props.aplikasi]);

    const tutup_notif = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setTampilNotif(false);
    };

    const tampil_penjualan = () => {
        let tahun = String(periode1.getFullYear());
        let bulan = String(periode1.getMonth() + 1);
        if (bulan.length === 1) {
            bulan = "0" + bulan;
        }
        let tanggal = String(periode1.getDate());
        if (tanggal.length === 1) {
            tanggal = "0" + tanggal;
        }

        let format_periode1 = tahun + "-" + bulan + "-" + tanggal;
        tahun = String(periode2.getFullYear());
        bulan = String(periode2.getMonth() + 1);
        if (bulan.length === 1) {
            bulan = "0" + bulan;
        }
        tanggal = String(periode2.getDate());
        if (tanggal.length === 1) {
            tanggal = "0" + tanggal;
        }

        let format_periode2 = tahun + "-" + bulan + "-" + tanggal;

        fetch(props.aplikasi + '/kasir/tampil_riwayat.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pengguna: localStorage.getItem("id_pengguna"),
                        periode1: format_periode1,
                        periode2: format_periode2
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataPenjualan(data.data);
                }
                else {
                    setDataPenjualan([]);
                }
            })
            .catch(error => {
                setDataPenjualan([]);
            }
            );
    }

    const tampil_penjualan_detail = (id_penjualan) => {
        fetch(props.aplikasi + '/kasir/tampil_penjualan_detail.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_penjualan: id_penjualan
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataPenjualanDetail(data.data);
                }
                else {
                    setDataPenjualanDetail([]);
                }
            })
            .catch(error => {
                setDataPenjualanDetail([]);
            }
            );
    }

    const switch_status_ubah = (param) => {
        switch (param) {
            case "N":
                return "Tidak Ada Permintaan";
            case "R":
                return "Menunggu Diterima";
            case "A":
                return "Diterima";
            case "D":
                return "Ditolak";
            default:
                break;
        }
    }

    const switch_warna_status_ubah = (param) => {
        switch (param) {
            case "N":
                return "red";
            case "R":
                return "gold";
            case "A":
                return "green";
            case "D":
                return "brown";
            default:
                break;
        }
    }

    const simpan = () => {
        if (metode_bayar.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Metode bayar wajib diisi");
            setTampilNotif(true);
            document.getElementById("metode_bayar").focus();
            return;
        }

        fetch(props.aplikasi + '/kasir/simpan_ubah_metode_bayar.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_penjualan: id_penjualan,
                        metode_sekarang: metode_bayar_sekarang,
                        metode_baru: metode_bayar,
                        id_pengguna: localStorage.getItem("id_pengguna")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setStatusUbah("R");
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    const simpan_anggota = () => {
        let id_anggota_baru = "";

        if (anggota !== null) {
            id_anggota_baru = anggota.id_karyawan;
        }

        fetch(props.aplikasi + '/kasir/simpan_ubah_pembeli.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_penjualan: id_penjualan,
                        id_anggota_sekarang: id_anggota_sekarang,
                        id_anggota_baru: id_anggota_baru,
                        id_pengguna: localStorage.getItem("id_pengguna")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setStatusUbahPembeli("R");
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    const hapus = () => {
        fetch(props.aplikasi + '/kasir/hapus_permintaan_ubah.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_penjualan: id_penjualan
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setTampilDialogUbah(false);
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    const hapus_anggota = () => {
        fetch(props.aplikasi + '/kasir/hapus_permintaan_ubah_anggota.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_penjualan: id_penjualan
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setTampilDialogUbahPembeli(false);
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    const simpan_pembatalan = () => {
        fetch(props.aplikasi + '/kasir/simpan_pembatalan.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_penjualan: id_penjualan,
                        id_pengguna: localStorage.getItem("id_pengguna")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    return (
        <div>
            <Snackbar
                open={tampil_notif}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={tutup_notif}
            >
                <Alert
                    severity={jenis_notif}
                    variant="filled"
                    onClose={tutup_notif}
                    sx={{ width: '100%' }}
                >
                    {isi_notif}
                </Alert>
            </Snackbar>

            <Box
                sx={{
                    backgroundColor: "#eff0f0",
                    width: "100%",
                    height: "100%"
                }}
            >
                <Grid container spacing={1} sx={{ padding: "10px" }}>
                    <Grid item xs={12}>
                        <Card
                            sx={{ padding: "10px" }}
                        >
                            <Grid container spacing={1}>
                                <Grid container item>
                                    <Grid item xs={12} sm={4} md={3} >
                                        <Typography variant="body2">
                                            Tanggal Transaksi
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={8} md={9} sx={{ display: "flex" }}>
                                        <Stack direction="row" spacing={1}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="dd-MM-yyyy"
                                                    value={periode1}
                                                    onChange={(newValue) => {
                                                        setPeriode1(newValue);
                                                    }}
                                                    renderInput={(params) => <TextField size='small' {...params} />}
                                                />
                                            </LocalizationProvider>

                                            <Typography variant="body2" sx={{ marginLeft: "10px", marginRight: "10px" }}>
                                                s/d
                                            </Typography>

                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="dd-MM-yyyy"
                                                    value={periode2}
                                                    onChange={(newValue) => {
                                                        setPeriode2(newValue);
                                                    }}
                                                    renderInput={(params) => <TextField size='small' {...params} />}
                                                />
                                            </LocalizationProvider>

                                            <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<PreviewIcon />}
                                                sx={{ borderRadius: "5em" }}
                                                onClick={() => {
                                                    tampil_penjualan();
                                                }}
                                            >
                                                Tampilkan
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            {data_penjualan.map((data_penjualan, index) => {
                                return (
                                    <Grid
                                        key={index}
                                        item xs={6} sm={4} md={3} lg={2}
                                        onClick={() => {
                                            setIdPenjualan(data_penjualan.id_penjualan);
                                            setIdAnggotaSekarang(data_penjualan.id_anggota);
                                            setNamaAnggotaSekarang(data_penjualan.nama_anggota);
                                            if (String(data_penjualan.metode_bayar2) === "") {
                                                setBayar(data_penjualan.metode_bayar);
                                            }
                                            else {
                                                setBayar(data_penjualan.metode_bayar + " & " + data_penjualan.metode_bayar2);
                                            }
                                            setKasir(data_penjualan.kasir);
                                            setWaktuTransaksi(data_penjualan.waktu_transaksi);
                                            setTotal(data_penjualan.subtotal);
                                            setDiskon(data_penjualan.diskon);
                                            setPembulatan(data_penjualan.pembulatan);
                                            setGrandTotal(data_penjualan.grand_total);
                                            tampil_penjualan_detail(data_penjualan.id_penjualan);
                                            setTampilDialog(true);
                                        }}
                                    >
                                        <Card sx={{ backgroundColor: "#66615b", color: "white" }}>
                                            <List>
                                                <ListItem button>
                                                    <ListItemText
                                                        primary={<Typography noWrap variant="subtitle1">{data_penjualan.nama_anggota !== "" ? data_penjualan.nama_anggota : "Umum"}</Typography>}
                                                        secondary={
                                                            <div>
                                                                <Typography noWrap variant="body2" color="white">
                                                                    Rp. {data_penjualan.grand_total}
                                                                </Typography>
                                                                <Typography noWrap variant="body2" color="white">
                                                                    {data_penjualan.waktu_transaksi}
                                                                </Typography>
                                                            </div>
                                                        }
                                                    >
                                                    </ListItemText>
                                                </ListItem>
                                            </List>
                                        </Card>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

            <Dialog
                fullScreen
                open={tampil_dialog}
            >
                <Box>
                    <AppBar
                        sx={{
                            display: 'flex'
                        }}
                    >
                        <Toolbar
                            sx={{ backgroundColor: "#35b2b8" }}
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => setTampilDialog(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                Detail Penjualan
                            </Typography>

                        </Toolbar>
                    </AppBar>

                    <Box sx={{ marginTop: "64px", padding: "10px" }}>
                        <Card sx={{ padding: "10px" }}>
                            <Typography variant="h6">
                                Data Penjualan
                            </Typography>
                            <Divider />
                            <br />

                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Typography variant="body2">
                                                No. Bukti
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                :
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                {id_penjualan}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography variant="body2">
                                                Nama
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                :
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                {nama_anggota_sekarang !== "" ? nama_anggota_sekarang : "Umum"}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography variant="body2">
                                                Kasir
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                :
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                {kasir}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography variant="body2">
                                                Metode Bayar
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                :
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                {bayar}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography variant="body2">
                                                Waktu Transaksi
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                :
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography variant="body2">
                                                {waktu_transaksi}
                                            </Typography>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Card>

                        <br />

                        <Card sx={{ padding: "10px" }}>
                            <Typography variant="h6">
                                Daftar Produk
                            </Typography>
                            <Divider />

                            <br />

                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<PrintIcon />}
                                sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#8080FF" }}
                                onClick={() =>
                                    window.open(props.aplikasi + '/kasir/cetak_struk.php?id_penjualan=' + id_penjualan)
                                }
                            >
                                Cetak
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<EditIcon />}
                                sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "tomato" }}
                                onClick={() => {
                                    fetch(props.aplikasi + '/kasir/tampil_ubah_metode_bayar.php',
                                        {
                                            method: 'POST',
                                            body: JSON.stringify
                                                ({
                                                    id_penjualan: id_penjualan
                                                }),
                                            headers:
                                            {
                                                "Content-type": "application/json; charset=UTF-8"
                                            }
                                        })
                                        .then(response => response.json())
                                        .then(data => {
                                            if (data.kode === 1) {
                                                setMetodeBayarSekarang(data.data[0].metode_bayar);
                                                setNamaMetodeBayarSekarang(data.data[0].nama_metode_bayar);
                                                setMetodeBayar(data.data[0].metode_baru);
                                                setStatusUbah(data.data[0].status_ubah);
                                            }
                                            else {
                                                setMetodeBayarSekarang("");
                                                setNamaMetodeBayarSekarang("");
                                                setMetodeBayar("");
                                                setStatusUbah("N");
                                            }
                                        })
                                        .catch(error => {
                                            setMetodeBayarSekarang("");
                                            setNamaMetodeBayarSekarang("");
                                            setMetodeBayar("");
                                            setStatusUbah("N");
                                        }
                                        );

                                    setTampilDialogUbah(true);
                                }}
                            >
                                Ubah Cara Bayar
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<EditIcon />}
                                sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "tomato" }}
                                onClick={() => {
                                    fetch(props.aplikasi + '/kasir/tampil_ubah_pembeli.php',
                                        {
                                            method: 'POST',
                                            body: JSON.stringify
                                                ({
                                                    id_penjualan: id_penjualan
                                                }),
                                            headers:
                                            {
                                                "Content-type": "application/json; charset=UTF-8"
                                            }
                                        })
                                        .then(response => response.json())
                                        .then(data => {
                                            if (data.kode === 1) {
                                                setAnggota(null);
                                                let tampung = [...data_anggota];
                                                let awal = 1;
                                                let akhir = tampung.length;
                                                while (awal <= akhir) {
                                                    if (data.data[0].id_anggota_baru === tampung[awal - 1]["id_karyawan"]) {
                                                        setAnggota(tampung[awal - 1]);
                                                        break;
                                                    }
                                                    awal++;
                                                }
                                                setStatusUbahPembeli(data.data[0].status_ubah);
                                            }
                                            else {
                                                setAnggota(null);
                                                setStatusUbahPembeli("N");
                                            }
                                        })
                                        .catch(error => {
                                            setAnggota(null);
                                            setStatusUbahPembeli("N");
                                        }
                                        );

                                    setTampilDialogUbahPembeli(true);
                                }}
                            >
                                Ubah Pembeli
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<DeleteIcon />}
                                sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "red" }}
                                onClick={() => {
                                    setTampilDialogPembatalan(true);
                                }}
                            >
                                Ajukan Pembatalan
                            </Button>
                            <br /><br />

                            <TableContainer component={Paper}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="center">Nama</StyledTableCell>
                                            <StyledTableCell align="center">Harga</StyledTableCell>
                                            <StyledTableCell align="center">Diskon</StyledTableCell>
                                            <StyledTableCell align="center">Jumlah</StyledTableCell>
                                            <StyledTableCell align="center">Satuan</StyledTableCell>
                                            <StyledTableCell align="center">Subtotal</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data_penjualan_detail.map((data_penjualan_detail) => {
                                            return (
                                                <StyledTableRow key={data_penjualan_detail.id_produk}>
                                                    <TableCell size="small"><Typography variant="body2" noWrap={true}>{data_penjualan_detail.nama}</Typography></TableCell>
                                                    <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{data_penjualan_detail.harga_jual2}</Typography></TableCell>
                                                    <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{data_penjualan_detail.diskon2}</Typography></TableCell>
                                                    <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{data_penjualan_detail.jumlah}</Typography></TableCell>
                                                    <TableCell size="small" align="center"><Typography variant="body2" noWrap={true}>{data_penjualan_detail.satuan}</Typography></TableCell>
                                                    <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{data_penjualan_detail.subtotal2}</Typography></TableCell>
                                                </StyledTableRow>
                                            );
                                        })}

                                        <TableRow>
                                            <TableCell align="right" colSpan={5}>
                                                <Typography variant="h6">
                                                    Total
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right"><Typography variant="h6" noWrap={true} sx={{ color: "green" }}>{total}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="right" colSpan={5}>
                                                <Typography variant="h6">
                                                    Diskon
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right"><Typography variant="h6" noWrap={true} sx={{ color: "green" }}>{diskon}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="right" colSpan={5}>
                                                <Typography variant="h6">
                                                    Pembulatan
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right"><Typography variant="h6" noWrap={true} sx={{ color: "green" }}>{pembulatan}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="right" colSpan={5}>
                                                <Typography variant="h6">
                                                    Grand Total
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right"><Typography variant="h4" noWrap={true} sx={{ color: "red" }}>{grand_total}</Typography></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>
                    </Box>
                </Box>
            </Dialog>

            <Dialog
                open={tampil_dialog_ubah}
                onClose={() => setTampilDialogUbah(false)}
            >
                <DialogTitle>Permintaan Pengubahan Metode Bayar</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Grid container item spacing={1}>
                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Metode Saat Ini
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <Typography variant="body2">
                                        {nama_metode_bayar_sekarang}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Menjadi
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <FormControl size="small" fullWidth>
                                        <Select
                                            id="metode_bayar"
                                            variant="outlined"
                                            fullWidth
                                            value={metode_bayar}
                                            onChange={(event) => {
                                                setMetodeBayar(event.target.value);
                                            }}
                                        >
                                            {data_metode_bayar.map((data_metode_bayar) => {
                                                return (
                                                    <MenuItem key={data_metode_bayar.id_metode} value={data_metode_bayar.id_metode}>{data_metode_bayar.nama}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Status Permintaan
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <Typography variant="body2"
                                        sx={{
                                            color: switch_warna_status_ubah(status_ubah)
                                        }}
                                    >
                                        {switch_status_ubah(status_ubah)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<SaveOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em" }}
                        onClick={() => simpan()}
                    >
                        <Typography variant="body2" noWrap={true}>Simpan</Typography>
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<DeleteIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "red" }}
                        onClick={() => setTampilDialogHapus(true)}
                    >
                        <Typography variant="body2" noWrap={true}>Hapus</Typography>
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<CloseOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#555555" }}
                        onClick={() => setTampilDialogUbah(false)}
                    >
                        <Typography variant="body2" noWrap={true}>Tutup</Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tampil_dialog_ubah_pembeli}
                onClose={() => setTampilDialogUbahPembeli(false)}
            >
                <DialogTitle>Permintaan Pengubahan Pembeli</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Grid container item spacing={1}>
                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Pembeli Saat Ini
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <Typography variant="body2">
                                        {nama_anggota_sekarang}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Menjadi
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <Autocomplete
                                        options={data_anggota}
                                        getOptionLabel={
                                            (option) => option.nama + " (" + option.bagian + ")"
                                        }
                                        value={anggota}
                                        onChange={(e, nilai) => setAnggota(nilai)}
                                        renderInput={
                                            (params) =>
                                                <TextField
                                                    {...params}
                                                    key={params.id_karyawan}
                                                    variant="outlined"
                                                    size="small"
                                                />
                                        }
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Status Permintaan
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <Typography variant="body2"
                                        sx={{
                                            color: switch_warna_status_ubah(status_ubah_pembeli)
                                        }}
                                    >
                                        {switch_status_ubah(status_ubah_pembeli)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<SaveOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em" }}
                        onClick={() => simpan_anggota()}
                    >
                        <Typography variant="body2" noWrap={true}>Simpan</Typography>
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<DeleteIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "red" }}
                        onClick={() => setTampilDialogHapusAnggota(true)}
                    >
                        <Typography variant="body2" noWrap={true}>Hapus</Typography>
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<CloseOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#555555" }}
                        onClick={() => setTampilDialogUbahPembeli(false)}
                    >
                        <Typography variant="body2" noWrap={true}>Tutup</Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tampil_dialog_hapus}
                onClose={() => setTampilDialogHapus(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Konfirmasi Hapus Permintaan
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin ingin menghapus data ini?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setTampilDialogHapus(false)} autoFocus>Tidak</Button>
                    <Button
                        onClick={() => {
                            hapus();
                            setTampilDialogHapus(false);
                        }}
                    >Ya</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tampil_dialog_hapus_anggota}
                onClose={() => setTampilDialogHapusAnggota(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Konfirmasi Hapus Permintaan
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin ingin menghapus data ini?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setTampilDialogHapusAnggota(false)} autoFocus>Tidak</Button>
                    <Button
                        onClick={() => {
                            hapus_anggota();
                            setTampilDialogHapusAnggota(false);
                        }}
                    >Ya</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tampil_dialog_pembatalan}
                onClose={() => setTampilDialogPembatalan(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Konfirmasi Pembatalan Transaksi
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin ingin membatalkan transaksi ini?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setTampilDialogPembatalan(false)} autoFocus>Tidak</Button>
                    <Button
                        onClick={() => {
                            simpan_pembatalan();
                            setTampilDialogPembatalan(false);
                        }}
                    >Ya</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default forwardRef(Riwayat_Penjualan);